import PageHeading from '../components/common/PageHeading';
import { newsItems } from '../data/siteContent';

function NewsPage() {
  return (
    <section className="page-section news-page" aria-labelledby="news-title">
      <PageHeading
        id="news-title"
        label="승마뉴스"
        title="승마 소식과 말타 이야기를 전합니다"
        description="서비스 공지, 파트너 소식, 승마를 더 쉽게 시작할 수 있는 콘텐츠를 모아봅니다."
      />
      <div className="news-grid">
        {newsItems.map((item) => (
          <article className="news-card" key={item.title}>
            <span>{item.category}</span>
            <h2>{item.title}</h2>
            <p>{item.body}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default NewsPage;
